// Puts the corner chat dock on every staff page for people who may chat. It sits outside the page routes, so the open
// windows and the live connection carry on while you move between pages. It is hidden when printing (dock.css).
import { Suspense, lazy } from 'react'
import { can, useAuth } from '../../../lib/auth'
import { useRouter } from '../../../lib/router'

const ChatDock = lazy(() => import('./ChatDock'))

// Chris wants the chat in front on every staff page, full-screen tools included; nothing is notify-only now.
const NOTIFY_ONLY: RegExp[] = []

export function ChatDockGate() {
  const { me } = useAuth()
  const { loc } = useRouter()
  const path = loc.path
  if (!me || me.mustChangePassword || (me.mfa.required && !me.mfa.totp)) return null
  if (!me.areas.includes('admin') || !can(me, 'chat.use')) return null
  if (!(path === '/admin' || path.startsWith('/admin/') || path === '/account')) return null
  return (
    <Suspense fallback={null}>
      <ChatDock me={me} hidden={NOTIFY_ONLY.some((r) => r.test(path))} />
    </Suspense>
  )
}
